module.exports = __webpack_public_path__ + "img/Flag_of_the_Vatican_City.5314bfac.svg";